import {BasicDescription} from "@fae/source/data/games/ember/views/Description.jsx"

let units = {}

/////////////
// RANGER //
///////////

units["dagger"] = {
    "jobKey": "dagger",
    "jobName": "Thief",
    "fequivalent": "Thief",
    "maxhealth": 20,
    "moverange": 2,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Daggers",
        "iconKey": "assassin-pocket",
        "description": BasicDescription,
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "daggers",
    }],

    "facts": [
        "Attacks from 2 tiles away. Strong against axes and guns.",
    ]
}

units["bow"] = {
    "jobKey": "bow",
    "jobName": "Archer",
    "fequivalent": "Archer",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Bow",
        "iconKey": "high-shot",
        "description": BasicDescription,
        "element": "water",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "bow",
    }],

    "facts": [
        "Attacks from 2 tiles away. Strong against swords and daggers.",
    ]
}

units["gun"] = {
    "jobKey": "gun",
    "jobName": "Gunman",
    "fequivalent": "Pirate",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Gun",
        "iconKey": "blunderboss",
        "description": BasicDescription,
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "gun",
    }],

    "facts": [
        "Attacks from 2 tiles away. Strong against spears and bows.",
    ]
}

/////////////////////
// RANGER MOUNTED //
///////////////////

units["bowcavalier"] = {
    "jobKey": "bowcavalier",
    "jobName": "Bowcavalier",
    "fequivalent": "Nomad",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Bow",
        "iconKey": "high-shot",
        "description": BasicDescription,
        "element": "water",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "bow",
    }],
}
// TODO: daggerhorse?
// TODO: gunhorse?

//////////////
// FIGHTER //
////////////

units["sword"] = {
    "jobKey": "sword",
    "jobName": "Swordsman",
    "fequivalent": "Mercenary",
    "attacktype": "steel",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Sword",
        "iconKey": "relic-blade",
        "description": BasicDescription,
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "sword",
    }],

    "facts": [
        "Strong against spears and bows.",
    ]
}

units["spear"] = {
    "jobKey": "spear",
    "jobName": "Spearman",
    "fequivalent": "Soldier",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Spear",
        "iconKey": "spear-hook",
        "description": BasicDescription,
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "spear",
    }],

    "facts": [
        "Strong against axes and guns.",
    ]
}

units["axe"] = {
    "jobKey": "axe",
    "jobName": "Axeman",
    "fequivalent": "Fighter",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Axe",
        "iconKey": "battered-axe",
        "description": BasicDescription,
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "axe",
    }],

    "facts": [
        "Strong against spears and bows.",
    ]
}

units["hammer"] = units["axe"] // an alias

//////////////////////
// FIGHTER MOUNTED //
////////////////////

units["swordcavalier"] = {
    "jobKey": "swordcavalier",
    "jobName": "Swordcavalier",
    "fequivalent": "Cavalier",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "red-helmet",

    "items": [{
        "title": "Sword",
        "iconKey": "relic-blade",
        "description": BasicDescription,
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "sword",
    }],
}

units["spearcavalier"] = {
    "jobKey": "spearcavalier",
    "jobName": "Spearcavalier",
    "fequivalent": "Paladin",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "blue-helmet",

    "items": [{
        "title": "Spear",
        "iconKey": "spear-hook",
        "description": BasicDescription,
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "spear",
    }],
}

units["axecavalier"] = {
    "jobKey": "axecavalier",
    "jobName": "Axecavalier", // ??
    "fequivalent": "Warlord",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "green-helmet",

    "items": [{
        "title": "Axe",
        "iconKey": "battered-axe",
        "description": BasicDescription,
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "axe",
    }],
}

//////////////////////
// FIGHTER ARMORED //
////////////////////

units["swordknight"] = {
    "jobKey": "swordknight",
    "jobName": "Swordknight",
    "fequivalent": "Swordknight",
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "red-shield",

    "items": [{
        "title": "Sword",
        "iconKey": "relic-blade",
        "description": BasicDescription,
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "sword",
    }],
}

units["spearknight"] = {
    "jobKey": "spearknight",
    "jobName": "Spearknight",
    "fequivalent": "Lancerknight",
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "blue-shield",

    "items": [{
        "title": "Spear",
        "iconKey": "spear-hook",
        "description": BasicDescription,
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "spear",
    }],
}

units["axeknight"] = {
    "jobKey": "axeknight",
    "jobName": "Axeknight", // ??
    "fequivalent": "Axeknight",
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "green-shield",
    "weaponImageKey": "axe",

    "items": [{
        "title": "Axe",
        "iconKey": "battered-axe",
        "description": BasicDescription,
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "axe",
    }],
}

///////////
// MAGE //
/////////

units["mage"] = {
    "jobKey": "mage",
    "jobName": "Mage",
    "fequivalent": "Mage",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Staff",
        "iconKey": "wizard-staff",
        "description": BasicDescription,
        "element": "fire",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "red-staff"
    }],
}

units["priest"] = {
    "jobKey": "priest",
    "jobName": "Priest",
    "fequivalent": "Priest",
    "skillKeys": ["heal"],
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Staff",
        "iconKey": "wizard-staff",
        "description": BasicDescription,
        "element": "water",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "blue-staff",
    }],
}

units["shaman"] = {
    "jobKey": "shaman",
    "jobName": "Shaman",
    "fequivalent": "Shaman",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "items": [{
        "title": "Staff",
        "iconKey": "wizard-staff",
        "description": BasicDescription,
        "element": "earth",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["attack"],
        "weaponImageKey": "green-staff",
    }],
}

units["nobody"] = {
    "jobKey": "nobody",
    "maxhealth": 20,
}

import games from "@fae/source/data/games/index.js"
Object.values(games).forEach((game) => {
    if(game == undefined) return
    if(game.unitJobs != undefined) {
        units = {
            ...units,
            ...game.unitJobs,
        }
    }
})

export default units
